import { render } from "./history-asesmen-detail.vue?vue&type=template&id=6dd95506&scoped=true"
import script from "./history-asesmen-detail.vue?vue&type=script&lang=js"
export * from "./history-asesmen-detail.vue?vue&type=script&lang=js"

import "./history-asesmen-detail.vue?vue&type=style&index=0&id=6dd95506&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd95506"]])

export default __exports__